if (!customElements.get('pg-product-shelf')) {
  customElements.define(
    'pg-product-shelf',
    class PgProductShelf extends HTMLElement {
      connectedCallback() {
        this.shuffleButton = this.querySelector('[data-pg-shuffle]');
        this.productList = this.querySelector('[data-pg-product-list]');
        this.status = this.querySelector('[data-pg-shuffle-status]');
        this.shuffleCount = 0;

        if (!this.shuffleButton || !this.productList || this.shuffleButton.dataset.bound === 'true') return;

        this.shuffleButton.dataset.bound = 'true';
        this.shuffleButton.addEventListener('click', () => this.shuffleProducts());
        this.shuffleProducts(true);
      }

      shuffleProducts(initial = false) {
        const products = Array.from(this.productList.children);
        const visibleLimit = Number.parseInt(this.productList.dataset.pgVisibleLimit, 10) || 8;
        const previousOrder = [...products];
        const previouslyVisible = new Set(products.filter((product) => !product.hidden));

        for (let index = products.length - 1; index > 0; index -= 1) {
          const swapIndex = Math.floor(Math.random() * (index + 1));
          [products[index], products[swapIndex]] = [products[swapIndex], products[index]];
        }

        const shownCount = Math.min(visibleLimit, products.length);
        // Prefer a genuinely new set over merely rearranging the current shelf.
        if (!initial && products.length > shownCount) {
          const fresh = products.filter((product) => !previouslyVisible.has(product));
          const repeats = products.filter((product) => previouslyVisible.has(product));
          products.splice(0, products.length, ...fresh, ...repeats);
        } else if (!initial && products.every((product, index) => product === previousOrder[index])) {
          products.push(products.shift());
        }

        products.forEach((product, index) => {
          product.hidden = index >= shownCount;
          this.productList.append(product);
        });
        if (!initial) this.shuffleCount += 1;

        if (this.status) {
          this.status.textContent = initial
            ? `Showing ${shownCount} randomly selected products from ${products.length} English and Japanese products.`
            : `Shelf shuffled ${this.shuffleCount} ${
            this.shuffleCount === 1 ? 'time' : 'times'
          }. Showing ${shownCount} of ${products.length} products.`;
        }
      }
    }
  );
}
